"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupProbabilitiesByOutcomeTypeId = groupProbabilitiesByOutcomeTypeId;
function groupProbabilitiesByOutcomeTypeId(probs) {
    return probs.reduce((acc, probability) => {
        if (acc[probability.outcomeTypeId] === undefined) {
            acc[probability.outcomeTypeId] = [];
        }
        acc[probability.outcomeTypeId].push(probability);
        return acc;
    }, {});
}
//# sourceMappingURL=groupProbabilitiesByOutcomeTypeId.js.map